"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { Star, Zap, Music } from "lucide-react";
const members = [{
  id: 1,
  name: "Ricardo Silva",
  role: "Conselheiro Estratégico",
  statLabel: "Liderança",
  statValue: 98,
  imgDefault: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/executive_ricardo_portrait.png",
  imgHover: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/executive_ricardo_action.png"
}, {
  id: 2,
  name: "Helena Costa",
  role: "Diretora de Networking",
  statLabel: "Conexões",
  statValue: 99,
  imgDefault: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/executive_helena_portrait.png",
  imgHover: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/executive_helena_action.png"
}, {
  id: 3,
  name: "Arthur Mendes",
  role: "Mentor de Carreira",
  statLabel: "Estratégia",
  statValue: 95,
  imgDefault: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/executive_arthur_portrait.png",
  imgHover: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/executive_arthur_action.png"
}, {
  id: 4,
  name: "Beatriz Lins",
  role: "Especialista em Longevidade",
  statLabel: "Visão",
  statValue: 99,
  imgDefault: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/executive_beatriz_portrait.png",
  imgHover: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/executive_beatriz_action.png"
}];
export default function TheLineup() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}